import { API_URL } from "../constants";
import { getHeaders } from "../utils";

export const getPropertyLease = async (propertyId) => {
  const response = await fetch(
    `${API_URL}/api/properties/${propertyId}/lease-settings`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );
  return response.json();
};

export const updatePropertyLease = async (propertyId, payload) => {
  const response = await fetch(
    `${API_URL}/api/properties/${propertyId}/lease-settings`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: getHeaders(),
    }
  );
  return response.json();
};
